import Box from 'component/layoutComponents/Box';
import styled from 'styled-components';
import { ICON_BUTTON_SIZE } from '../commentInput/commentInput.style';

interface StyledReactQuillProps {
  showToolbar: boolean;
  isMobile?: boolean;
}

const EDITOR_HEIGHT = 46;
const PADDING_X = {
  DESKTOP: 20,
  MOBILE: 12,
};
const PADDING_Y = 11;

export const StyledReactQuill = styled(Box)<StyledReactQuillProps>(({ theme, showToolbar, isMobile }) => `
  --padding-x: ${isMobile ? PADDING_X.MOBILE : PADDING_X.DESKTOP}px;
  * {
    font-family: inherit;
  }

  .quill {
  }
  
  .ql-toolbar {
    display: ${showToolbar ? 'block' : 'none'};
    padding: ${PADDING_Y}px 'var(--padding-x)' ${PADDING_Y - 1}px; // -1 to fix the bottom border
    border: none;
    border-bottom: 1px solid ${theme.uptimeColors.grayScales.gray};

    button:hover,
    button:focus,
    button.ql-active,
    .ql-picker-label:hover,
    .ql-picker-label.ql-active,
    .ql-picker-item:hover,
    .ql-picker-item.ql-selected {
      color: ${theme.uptimeColors.mainTheme.primary} !important;
      
      svg * {
        stroke: ${theme.uptimeColors.mainTheme.primary} !important;
      }
    }
  }
  
  .ql-picker.ql-header {
    margin-left: -${theme.uptimeSpace[2]}px;
  }

  .ql-picker-label {
    border: none;
    padding: 0 ${theme.uptimeSpace[2]}px;
  }

  .ql-container {
    border: none;
    padding: 0 ${showToolbar || isMobile ? 'var(--padding-x)' : '132px'} 0 var(--padding-x);

    a {
      color: ${theme.uptimeColors.mainTheme.primary};
    }
  }
  
  .ql-editor {
    display: grid;
    min-height: ${EDITOR_HEIGHT}px;
    max-height: 98px;
    padding: ${theme.uptimeSpace[4]}px 0;
    font-size: ${theme.uptimeFontSizes.desktop.fz4}px;

    /* placeholder */
    &.ql-blank::before {
      left: unset;
      right: unset;
      top: 50%;
      transform: translateY(-50%);
      font-style: unset;
    }

    *:first-child {
      margin: auto 0;
    }
  }
  .ql-tooltip {
    z-index: 100;
  }
`);

export const StyledButtonGroup = styled(Box)<{ isMobile?: boolean }>(({ theme, isMobile }) => `
  position: ${isMobile ? 'none' : 'absolute'};
  right: ${theme.uptimeSpace[8]}px;
  top: ${(EDITOR_HEIGHT - ICON_BUTTON_SIZE) / 2}px;
  display: flex;
  gap: ${theme.uptimeSpace[4]}px;
  padding: ${isMobile ? theme.uptimeSpace[4] : 0}px ${isMobile ? PADDING_X.MOBILE : 0}px;

  button {
    padding: 0;

    &:not(:disabled):hover {
      color: ${theme.uptimeColors.mainTheme.primary};
    }
  }
`);
